import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useRef, useState } from "react";
import styled from "styled-components";

import { Link, useNavigate } from "react-router-dom";

const EventRap = styled.div`
  background: #ffffff;
  border-radius: 20px;
  padding: 30px;
  .events h4 {
    color: #060b13;
    font-size: 14px;
    font-weight: 400;
    padding: 15px;
    padding-bottom: 25px;
    background: #060b130a;
    border: 1px solid #bac0d499;
    max-width: 430px;
    border-radius: 15px;
  }
  .all-events h2 {
    color: #060b13;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 15px;
  }
  .events p {
    padding: 15px;
    border-radius: 100px;
    background: #060b130a;
    border: 1px solid #bac0d499;
    width: 430px;
    margin-bottom: 20px;
  }
  .event-links {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 298px;
    padding: 15px;
  }
  .event-links span {
    color: #ed1c24;
  }
  .event-links p {
    color: #363d4f;
    font-weight: 400;
    font-size: 14px;
  }
  .event-links {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .event-links-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border: 1px solid #bac0d499;
    border-radius: 50%;
  }
  .event-links-sent {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .delete-button,
  .edit-button {
    border-top: 1px;
    border-right: 4px;
    border-bottom: 4px;
    border-left: 1px;
    border-radius: 100px;
    background: #ffffff;
    padding: 12px 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-style: solid;
    color: #060b13;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    border-color: #060b13;
  }
  .edit-button {
    background: #ed1c24;
    color: #ffffff;
  }
  .event-buttons {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  .all-events,
  .events {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }
  .event-image-div {
    background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0) 20.95%,
        rgba(0, 0, 0, 0.659617) 81.51%,
        #000000 103.25%
      ),
      url("../images/image_1.png");
    background-size: cover; /* Ensures the image covers the element */
    background-position: center;
    height: 357px;
    width: 720px;
  }
  .event-sub {
  }
  .timezone p {
    color: #828286;
    font-size: 12px;
    font-weight: 400;
  }
  .timezone p a {
    text-decoration: none;
    color: #ed1c24;
  }
  .timezone {
    position: relative;
  }
  .timezone-dropdown {
    padding: 0;
    border: 1px solid #ddd;
    border-radius: 15px;
    width: 300px;
    background: #ffffff;
    position: absolute;
    z-index: 9999;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  .time-input,
  .calendar-container input {
    width: 210px;
    height: 50px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 15px;
    border: 0.8px solid #bac0d4b2;

    font-weight: 400;
    font-size: 12px;
  }
  .time-dropdown {
    border: 0.6px solid #d0d5dd;
    box-shadow: 0px 8px 22px 0px #2230491a;
    width: 207px;
    background: #ffffff;
    padding: 20px;
    margin-top: 10px;
    padding-right: 10px;
    border-radius: 10px;
    position: absolute;
    z-index: 1000;
  }
  .time-dropdown p {
    color: #060b13;
    font-weight: 400;
    text-align: center;
    font-size: 12px;
  }
  .time-dropdown-div {
    max-height: 240px;
    overflow-y: scroll;
    padding: 5px 10px;
  }
  .time-dropdown-div::-webkit-scrollbar {
    width: 6px;
  }

  .time-dropdown-div::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  .time-dropdown-div::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .time-dropdown-div::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .time-dropdown-div::-webkit-scrollbar-button {
    display: none;
  }
  .the-time {
    padding: 10px;
    cursor: pointer;
    border-radius: 6px;
    color: #060b13;
    font-weight: 500;
    font-size: 12px;
  }
  .time-cancel {
    border: none;
    color: #060b13;
    font-size: 14px;
    font-weight: 400;
    background: #ffffff;
  }
  .time-save {
    background: #ed1c24;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    border: none;
    width: 66px;
    height: 32px;
    border-radius: 8px;
  }
  .calendar-container {
    position: relative;
    max-width: 344px;
  }

  .calendar-dropdown {
    position: absolute;
    top: 50px;
      right: 20%;
    background: white;
    border: 0.6px solid #d0d5dd;
    border-radius: 10px;
    padding: 15px;
    margin-top: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    max-width: 344px;
    z-index: 10;
  }

  .calendar-header {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 10px;
    color: #1e1e1c;
    font-size: 14px;
    font-weight: 400;
  }

  .calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
  }

  .calendar-day {
    padding: 10px;
    text-align: center;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    color: #1e1e1c;
    font-weight: 400;
  }

  .today {
    color: #ed1c24;
  }

  .selected {
    background: #ed1c24;
    color: white;
    border-radius: 50%;
  }

  .other-month {
    color: #828280;
  }
  .start-date-time {
    display: flex;
    gap: 10px;
  }
  .category-input {
    width: 430px;
    height: 50px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0px;
    border-radius: 100px;
    border: 0.8px solid #bac0d4b2;
  }
  .category-input p {
    color: #060b13;
    font-weight: 400;
    font-size: 14px;
    padding: 0px 15px;
  }
  .category {
    position: relative;
  }
  .category-dropdown {
    border: 0.6px solid #d0d5dd;
    box-shadow: 0px 8px 22px 0px #2230491a;
    background: #ffffff;
    width: 430px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    gap: 15px;
    padding: 10px;
    z-index: 9999;
    position: absolute;
    margin-top: 10px;
  }
  .category-dropdown p {
    color: #060b13;
    font-weight: 400;
    font-size: 14px;
    padding: 10px;
  }
  .category-dropdown p:hover {
    background: #e8e9eb;
    border-radius: 6px;
  }
  input {
    border: 0.8px solid #bac0d4b2;
    width: 430px;
    height: 50px;
    border-radius: 100px;
    color: #060b13;
    font-weight: 400;
    font-size: 14px;
    padding-left: 15px;
  }
  .custom-radio {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #060b13;
  }

  .custom-radio input[type="radio"] {
    display: none; /* Hide default radio button */
  }

  .radio-checkmark {
    height: 20px;
    width: 20px;
    border: 2px solid red;
    border-radius: 50%;
    margin-right: 10px;

    position: relative;
  }

  .custom-radio input[type="radio"]:checked + .radio-checkmark {
    background-color: transparent;
  }

  .custom-radio input[type="radio"]:checked + .radio-checkmark:before {
    content: "";
    position: absolute;
    top: 3px;
    left: 3px;
    height: 10px;
    width: 10px;
    background-color: red;
    border-radius: 50%;
  }

  .upload-img-div {
    display: inline-block;
    padding: 8px 16px;
    background: #e8e9eb;

    color: #060b13 !important;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 400;
  }
  .fileInput {
    display: none;
  }
  .tap-to-upload h6 {
    font-size: 14px;
    color: #171717;
    font-weight: 500;
  }
  .file-upload {
    width: 201px;
    height: 83px;

    justify-content: center;
    display: flex;
    gap: 16px;
    border-radius: 15px;
    align-items: center;
    border: 0.8px solid #bac0d4b2;
  }
  .tap-to-upload p {
    font-size: 12px;
    color: #9499ac;
    font-family: "Inter";
  }
  .uploadedImage {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .uploadedImage p {
    font-weight: 400;
    max-width: 201px;
    font-size: 12px;
    color: #828286;
  }
  .uploadedImage-default {
    max-width: 201px;
    height: 83px;
    border-radius: 5px;
  }
  .add-uploaded-divs {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  .all-dropdown-div {
    max-width: 500px;
    max-height: 546px;
    background: #ffffff;
    border-radius: 16px;
  }
  .schedule-btn {
    border-top: 1px;
    border-right: 4px;
    border-bottom: 4px;
    border-left: 1px;
    border-style: solid;
    width: 430px !important;
    height: 50px !important;
    border-radius: 100px;
    padding: 12px;
    background: #ed1c24;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    border-color: #060b13;
  }
  .audio-icon-div {
    background: #e4e5e7;
    width: 28px;
    border-radius: 50%;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .audio-icon-div img {
    height: 16px;
    width: 19px !important;
  }
  .recording-upload-dic {
    height: 120px;
    max-width: 430px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border-radius: 15px;
    border: 0.7px solid #bac0d4b2;
    padding: 20px;
  }
  .click-upload {
    color: #828286;
    font-size: 12px;
    font-weight: 400;
  }
  .click-upload span {
    color: #ed1c24;
    font-weight: 600;
  }
  .the-upload-input {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
  .delete-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    width: 500px;
    height: 276px;
  }
  .delete-div p {
    color: #828286;
    max-width: 257px;
    line-height: 20px;
    font-size: 12px;
    text-align: center;
    font-weight: 400;
  }
  .delete-div h4 {
    color: #060b13;
    font-size: 18px;
    font-weight: 500;
  }
  .move-back-icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0.7px solid #828286;
  }
  .events-head {
    display: flex;

    gap: 10px;
  }

  input[type="range"]::-webkit-slider-thumb {
    appearance: none;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #ed1c24;
    cursor: pointer;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  }

  input[type="range"]::-moz-range-thumb {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #ed1c24;
    cursor: pointer;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  }

  input[type="range"]::-ms-thumb {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #ed1c24;
    cursor: pointer;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  }
  .all-divs-record {
    width: 100%;
    border: 1px solid #bac0d499;
    max-width: 430px;
    border-radius: 15px;
    padding: 20px;
    text-align: center;
    margin: 20px auto;
  }
  .embed-sub {
    display: flex;
    gap: 7px;
  }
  .embed-sub h6 {
    color: #060b13;
    font-size: 14px;
    font-weight: 400;
  }

  .embed {
    display: flex;
    justify-content: space-between;
    border: 1px solid #bac0d499;
    padding: 10px 23px;
    height: 50px;
    align-items: center;
    width: 430px;
    cursor: pointer;
    border-radius: 100px;
    margin-bottom: 20px;
  }
  .code-icon {
    height: 18px;
    width: 18px;
  }
  .em-img {
    height: 20px;
    width: 20px;
  }
  .event-p-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .link-container {
    display: flex;
    gap: 15px;
  }
  .link {
    text-decoration: none;
    color: #818893;
    font-size: 14px;
    font-weight: 500;
    padding-bottom: 10px;
  }
  .link.active {
    color: #060b13;
    border-bottom: 3px solid #000000;
  }
  .link-sub-event {
    display: flex;
    justify-content: space-between;
  }
  .embed-rocording-pop p {
    max-width: 430px !important;
    border-radius: 15px;
    background: #060B130A;
    border: 1px solid #BAC0D499;
    padding: 15px;
    font-weight: 400;
    font-size: 14px;
    color: #060B13;
  }
  .embed-rocording-pop button {
    border-left: 1px;
    border-top: 1px;
    border-bottom: 4px;
    border-right: 4px;
    border-style: solid;
    border-radius: 100px;
    width: 430px;
    height: 50px;
    border-color: #060B13;
 margin-top: 20px;

  }
  .embed-rocording-pop  {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
`;

const RecordingDetails = () => {
  const navigate = useNavigate();
  const [uploadState, setUploadState] = useState("default"); // "default", "uploading", "success", "error"
  const [fileName, setFileName] = useState("");
  const [showAcess, setShowAccess] = useState(false);
  const [selectedAccess, setSelectedAccess] = useState("Access type");
  const [popScheduleLates, setPopScheduleLater] = useState(false);
  const [activeLink, setActiveLink] = useState("wide");

  const [selectedOption, setSelectedOption] = useState("default");
  const [uploadedImage, setUploadedImage] = useState(null);
  const [showDeleteEvent, setShowDeleteEvent] = useState(false);
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
    const [embededDrop, setEmbededDrop] = useState(false)


    const handleEmbededDrop = () => {
        setEmbededDrop(!embededDrop)
    }


  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

  // Format time (e.g., 0:30)
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  // Play or pause the audio
  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  // Update current time and progress
  const handleTimeUpdate = () => {
    setCurrentTime(audioRef.current.currentTime);
  };

  // Skip forward/backward
  const skipTime = (amount) => {
    audioRef.current.currentTime += amount;
  };

  // Handle loaded metadata to get duration
  const handleLoadedMetadata = () => {
    setDuration(audioRef.current.duration);
  };

  const handleShowDeleteEvent = () => {
    setShowDeleteEvent(!showDeleteEvent);
  };

  const handleShowAccess = () => {
    setShowAccess(!showAcess);
  };

  const handleSelectAccess = (access) => {
    setSelectedAccess(access); // Update the selected category
    setShowAccess(false); // Close the dropdown
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      setFileName(file.name);
      if (file.type === "video/mp4") {
        setUploadState("uploading");

        // Simulate file upload process
        setTimeout(() => {
          setUploadState("success");
        }, 2000);
      } else {
        setUploadState("error");
      }
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];

    if (file) {
      setFileName(file.name);
      if (file.type === "video/mp4") {
        setUploadState("uploading");

        // Simulate file upload process
        setTimeout(() => {
          setUploadState("success");
        }, 2000);
      } else {
        setUploadState("error");
      }
    }
  };

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setUploadedImage(e.target.result); // Set the uploaded image
      };
      reader.readAsDataURL(file);
    }
  };

  const handlePopScheduleLater = () => {
    setPopScheduleLater(!popScheduleLates);
  };

  const handleGoToDetails = () => {
    navigate("/users/recordings");
  };
  return (
    <EventRap>
      <div className="all-events">
        <div>
          <div className="events-head">
            <div onClick={handleGoToDetails} className="move-back-icon">
              <Icon
                icon="iconamoon:arrow-left-2-light"
                width="18"
                height="18"
                style={{ color: "#363D4F", cursor: "pointer" }}
              />
            </div>
            <h2>Recording details</h2>
          </div>

          <div className="events">
            <div className="event-image-div"></div>
            <div className="event-sub">
              <div className="all-divs-record">
                {/* Audio Element */}
                <audio
                  ref={audioRef}
                  src="your-audio-file.mp3" // Replace with your audio file URL
                  onTimeUpdate={handleTimeUpdate}
                  onLoadedMetadata={handleLoadedMetadata}
                ></audio>

                {/* Playback Controls */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "20px",
                  }}
                >
                  <button
                    onClick={() => skipTime(-15)}
                    style={{
                      background: "none",
                      border: "none",
                      fontSize: "18px",
                      color: "#333",
                      cursor: "pointer",
                      margin: "0 10px",
                    }}
                  >
                    <img src="/images/left_play.png" alt="" />
                  </button>

                  <button
                    onClick={togglePlay}
                    style={{
                      background: "red",
                      color: "white",
                      border: "none",
                      borderRadius: "50%",
                      width: "40px",
                      height: "40px",
                      cursor: "pointer",
                      fontSize: "18px",
                    }}
                  >
                    {isPlaying ? "❚❚" : "▶"}
                  </button>

                  <button
                    onClick={() => skipTime(15)}
                    style={{
                      background: "none",
                      border: "none",
                      fontSize: "18px",
                      color: "#333",
                      cursor: "pointer",
                      margin: "0 10px",
                    }}
                  >
                    <img src="/images/right_play.png" alt="" />
                  </button>
                </div>

                {/* Progress Bar */}
                <div style={{ marginTop: "10px", position: "relative" }}>
                  <input
                    type="range"
                    min="0"
                    max={duration}
                    value={currentTime}
                    onChange={(e) =>
                      (audioRef.current.currentTime = e.target.value)
                    }
                    style={{
                      width: "100%",
                      appearance: "none",
                      height: "4px",
                      borderRadius: "4px",
                      outline: "none",
                      border: "none",
                      background: "#BAC0D499",
                    }}
                  />
                </div>

                {/* Time Display */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "10px",
                    fontSize: "14px",
                    color: "#666",
                  }}
                >
                  <span>{formatTime(currentTime)}</span>
                  <span>{formatTime(duration)}</span>
                </div>
              </div>

              <p>Public</p>
              <h4>
                Network conference, where industry leaders will discuss the
                latest trends and innovations shaping the future of technology.{" "}
              </h4>
              <div className="event-links-sent">
                <div className="event-links">
                  <p
                    style={{
                      background: "white",
                    }}
                    className="event-p-flex"
                  >
                    Event link:
                    <span>https://rccglag56...</span>
                    <img
                      className="em-img"
                      src="/images/copy_icon.png"
                      alt=""
                    />
                  </p>
                </div>
                <div className="event-links-icon">
                  <Icon
                    icon="basil:facebook-solid"
                    width="16"
                    height="16"
                    style={{ color: "#060B13", cursor: "pointer" }}
                  />
                </div>
                <div className="event-links-icon">
                  <Icon
                    icon="ri:linkedin-fill"
                    width="16"
                    height="16"
                    style={{ color: "#060B13", cursor: "pointer" }}
                  />
                </div>
                <div className="event-links-icon">
                  <Icon
                    icon="mdi:twitter"
                    width="16"
                    height="16"
                    style={{ color: "#060B13", cursor: "pointer" }}
                  />
                </div>
              </div>

              <div onClick={handleEmbededDrop} className="embed">
                <div className="embed-sub">
                  <img
                    className="code-icon"
                    src="/images/code_icon.png"
                    alt=""
                  />
                  <h6>Embed recording</h6>
                </div>
                <img className="em-img" src="/images/embed.png" alt="" />
              </div>

              <div className="event-buttons">
                <button
                  onClick={handleShowDeleteEvent}
                  className="delete-button"
                >
                  <Icon
                    icon="hugeicons:delete-01"
                    width="18"
                    height="18"
                    style={{ color: "#060B13", cursor: "pointer" }}
                  />
                  Delete
                </button>
                <button
                  onClick={handlePopScheduleLater}
                  className="edit-button"
                >
                  <Icon
                    icon="solar:pen-line-duotone"
                    width="18"
                    height="18"
                    style={{ color: "#ffffff", cursor: "pointer" }}
                  />
                  Edit event
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        {popScheduleLates ? (
          <div className="dropdown-container">
            <div className="all-dropdown-div">
              <div className="dropdown-header">
                <h4>Upload recordings</h4>
                <Icon
                  onClick={handlePopScheduleLater}
                  icon="mdi:times"
                  width="16"
                  height="16"
                  style={{ color: "#828286", cursor: "pointer" }}
                />
              </div>
              <div className="dropdown-div">
                <div>
                  <input type="text" placeholder="Recording title" />
                </div>
                <div
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                  className="recording-upload-dic"
                >
                  {uploadState === "default" && (
                    <>
                      <input
                        type="file"
                        accept=".mp4"
                        onChange={handleFileUpload}
                        style={{ display: "none" }}
                        id="file-upload"
                      />
                      <label
                        htmlFor="file-upload"
                        style={{ cursor: "pointer" }}
                        className="the-upload-input"
                      >
                        <div className="audio-icon-div">
                          <img src="/images/audio-icon.png" alt="audio wave" />
                        </div>
                        <p className="click-upload">
                          <span>Click to upload </span>
                          or drag and drop
                        </p>

                        <p className="click-upload">
                          MP4 only (max size: 800x400px)
                        </p>
                      </label>
                    </>
                  )}

                  {uploadState === "uploading" && (
                    <div>
                      <div className="audio-icon-div">
                        <img src="/images/audio-icon.png" alt="audio wave" />
                      </div>
                      <p>{fileName}</p>
                      <p>200 KB - 100% uploading</p>
                    </div>
                  )}

                  {uploadState === "success" && (
                    <div>
                      <p>File uploaded successfully!</p>
                      <p>{fileName}</p>
                    </div>
                  )}

                  {uploadState === "error" && (
                    <div>
                      <div className="audio-icon-div">
                        <img src="/images/audio-icon.png" alt="audio wave" />
                      </div>
                      <p style={{ color: "red" }}>
                        Upload failed, please{" "}
                        <span style={{ textDecoration: "underline" }}>
                          Try again
                        </span>
                      </p>
                      <p>{fileName}</p>
                    </div>
                  )}
                </div>
                <div className="category">
                  <div onClick={handleShowAccess} className="category-input">
                    <p>{selectedAccess}</p>{" "}
                    {/* Display the selected category */}
                  </div>
                  {showAcess && (
                    <div className="category-dropdown">
                      <p onClick={() => handleSelectAccess("Public")}>Public</p>
                      <p onClick={() => handleSelectAccess("Only me")}>
                        Only me
                      </p>
                      <p onClick={() => handleSelectAccess("Unlisted")}>
                        Unlisted
                      </p>
                    </div>
                  )}
                </div>
                <div>
                  <input
                    className="schedules-inp"
                    style={{
                      height: "120px",
                      borderRadius: "15px",
                      textAlign: "start",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                    }}
                    type="text"
                    placeholder="Event Description"
                  />
                </div>
                <div className="add-uploaded-divs">
                  <div>
                    <label className="custom-radio">
                      <input
                        type="radio"
                        value="default"
                        checked={selectedOption === "default"}
                        onChange={handleRadioChange}
                      />
                      <span className="radio-checkmark"></span>
                      Use default theme
                    </label>

                    <label className="custom-radio">
                      <input
                        type="radio"
                        value="upload"
                        checked={selectedOption === "upload"}
                        onChange={handleRadioChange}
                      />
                      <span className="radio-checkmark"></span>
                      Upload image
                    </label>
                  </div>

                  {selectedOption === "default" && (
                    <div>
                      <img
                        className="uploadedImage-default"
                        src="/images/image_1.png" // Replace with your default image URL
                        alt="Default Theme"
                        style={{
                          width: "300px",
                          height: "150px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                  )}

                  {selectedOption === "upload" && (
                    <div>
                      {!uploadedImage ? (
                        <div className="uploadedImage">
                          <div className="file-upload">
                            <label className="upload-img-div">
                              Choose Image
                              <input
                                onChange={handleImageUpload}
                                type="file"
                                accept="image/*"
                                className="fileInput"
                              />
                            </label>
                          </div>
                          <p>
                            JPG or PNG accepted, Max size 10mb. (Default size:
                            1400x800)
                          </p>
                        </div>
                      ) : (
                        <img
                          className="uploadedImage-default"
                          src={uploadedImage}
                          alt="Uploaded"
                          style={{
                            width: "300px",
                            height: "150px",
                            border: "1px solid #ccc",
                          }}
                        />
                      )}
                    </div>
                  )}
                </div>
                <button className="schedule-btn">Schedule event</button>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <div>
        {showDeleteEvent ? (
          <div className="dropdown-container">
            <div className="all-dropdown-div">
              <div className="delete-div">
                <h4>Successful</h4>
                <p>
                  You have successfully edited schedule Tech summit 2024 event
                  for later{" "}
                </p>
                <div className="event-buttons">
                  <button
                    onClick={() => setShowDeleteEvent(false)}
                    className="delete-button"
                  >
                    Cancel
                  </button>
                  <button className="edit-button">See details</button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      <div>
        {embededDrop? (
        <div className="dropdown-container">
          <div className="all-dropdown-div">
          <div className="dropdown-header">
                <h4>Embed recordings</h4>
                <Icon
                  onClick={handleEmbededDrop}
                  icon="mdi:times"
                  width="16"
                  height="16"
                  style={{ color: "#828286", cursor: "pointer" }}
                />
              </div>
            <div className="dropdown-div">
            <div className="link-container">
              <Link
                className={`link ${activeLink === "wide" ? "active" : ""}`}
                onClick={() => handleLinkClick("wide")}
              >
                Wide
              </Link>
              <Link
                className={`link ${activeLink === "square" ? "active" : ""}`}
                onClick={() => handleLinkClick("square")}
              >
                Square
              </Link>
            </div>
            <div className="embed-rocording-pop">
                
                {activeLink==="wide" &&
                 <img style={{
                    width: "430px",
                    height: "246px",
                 }} src="/images/image_1.png" alt="" />
                }
                {activeLink==="square" &&
                 <img style={{
                    width: "300px",
                    height: "300px",
                    borderRadius:"15px"
                 }} src="/images/image_1.png" alt="" />
                }
                <p> iframe style="border: 1px solid rgba(0, 0, 0, 0.1);"
                     width="800" height="450" src="https://www.figma.com/embed?embed_ 
                     host=share&url=https%3A%2F%2F 
                     www.figma.com%2Ffile%2FEcq0wMjcu9VZWfguJtFxnm%2
                     
                     Fpluglr%3Ftype%3Ddesign%26node-id%3D240%253A663%26mode
                     %3Ddesign%26t%3DJcFwKHz9BiaEurhn-1" 
                     allowfullscreen </p>
                <button>Copy embed code</button>
            </div>
            </div>
          </div>
        </div>
        ): ""}
      </div>
    </EventRap>
  );
};

export default RecordingDetails;
